import { render, staticRenderFns } from "./ChargeBox.vue?vue&type=template&id=53609df2"
import script from "./ChargeBox.vue?vue&type=script&lang=js"
export * from "./ChargeBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports